/*
 * @Author: zhaozhuo
 * @Date: 2022-02-16 11:08:35
 * @LastEditors: zhangquanming 419654548@qq.com
 * @LastEditTime: 2024-02-21 17:56:28
 * @Description: file content
 * @FilePath: \edc-mobile-web\src\router\baseRoute.js
 */
export default [
	{
		path: '/home',
		name: 'Home',
		component: resolve => require(['../views/home/index.vue'], resolve) // 选择主页
	},
	{
		path: '/login',
		name: 'Login',
		component: resolve => require(['../views/login/index.vue'], resolve) // 登录界面
	},
	{
		path: '/',
		redirect: '/home'
	},
	{
		path: '*',
		redirect: '/404'
	},
	{
		path: '/404',
		name: '404',
		component: resolve => require(['../views/remind/404/index.vue'], resolve) // 404界面
	},
	{
		path: '/follow',
		name: 'Follow',
		component: resolve => require(['../views/remind/follow/index.vue'], resolve) // 关注公众号引导页
	},
	{
		path: '/commitSuccess',
		name: 'CommitSuccess',
		component: resolve => require(['../views/remind/commitSuccess/index.vue'], resolve)// 提交成功
	},
	{
		path: '/canlender',
		name: 'Canlender',
		component: resolve => require(['../views/visit/canlender/index.vue'], resolve)// 日历
	},
	{
		path: '/support',
		name: 'Support',
		component: resolve => require(['../views/contactUs/index.vue'], resolve)	// 联系我们
	},
	{
		path: '/qrcode',
		name: 'Qrcode',
		component: resolve => require(['../views/qrcode/index.vue'], resolve)	// 二维码页面
	},
	{
		path: '/qrcodexmz',
		name: 'QrcodeXmz',
		component: resolve => require(['../views/qrcodexmz/index.vue'], resolve)	// 荨麻疹二维码页面
	},
	{
		path: '/preach',
		name: 'Preach',
		meta: {
			isHideGoBack: true
		},
		component: resolve => require(['../views/preach/index.vue'], resolve)	// 宣教知识查看
	}
]